import { render, staticRenderFns } from "./S2_P3_Payments.vue?vue&type=template&id=3ad8f576&scoped=true&"
import script from "./S2_P3_Payments.vue?vue&type=script&lang=js&"
export * from "./S2_P3_Payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8f576",
  null
  
)

export default component.exports